import { Button, Grid, Paper, Tabs, Tab, Box } from "@mui/material"
import { DataGrid } from "@mui/x-data-grid"
import React, { useEffect, useState } from "react"
import ModalDialogPage from "src/components/modal-dialog"
import SimuladorService from "src/services/simulador-service"
import { localeBRDataGridText } from "src/utils/data-grid-local-text"
import PropTypes from 'prop-types'
import dayjs from "dayjs"
import { DATE_TIME_FORMAT_SHOW, DATE_FORMAT_SHOW } from "src/utils/constants"
import { formatDateUtc } from "src/utils/date-format"
import { formatStringToFloatDecimalCase } from "src/utils/format-decimal"


const SimuladorSubordinacaoHistorico = (props) => {
    const service = new SimuladorService()
    const [rows, setRows] = useState([])
    const [rowsSubordinacaoSimulado, setRowsSubordinacaoSimulado] = useState([])
    const [openModalDetailSubordinacao, setOpenModalDetailSubordinacao] = useState(false)

    const [tabIndex, setTabIndex] = useState(0)
    const [parametrosSimulacao, setParametrosSimulacao] = useState(null)
    const [rowsParametros, setRowsParametros] = useState([])

    console.log('PARAMETROS SIMULAÇÃO:', parametrosSimulacao)

    useEffect(() => {
        loadHistory()
    }, [])

    const loadHistory = () => {
        props.setLoading(true)
        service.getHistorico().then((response) => {
            const { body } = response
            const rows = body.map((obj, index) => ({ ...obj, id: index }))
            setRows(rows)
        }).catch(() => {

        }).finally(() => { props.setLoading(false) })
    }

    const openModalDetail = (params) => {
        props.setLoading(true)
        const { row } = params
        const { uuid } = row

        service.getHistoricoSimulado(uuid).then((response) => {
            const { body } = response

            const { results, subordinacaoEntrada } = body
            const parametros = subordinacaoEntrada

            const rows = results.map((obj, index) => ({ ...obj, id: index }))

            setRowsSubordinacaoSimulado(rows)
            setParametrosSimulacao(parametros)

            if (parametros) {
                setRowsParametros([{
                    id: 1,
                    TipoSimulacao: parametros.TipoSimulacao,
                    TipoPDD: parametros.TipoPDD,
                    NomeCarteira: parametros.NomeCarteira,
                    QuantidadeOperacoes: parametros.QuantidadeOperacoes,
                    PLTotal: parametros.PLTotal,
                    Percentil: parametros.Percentil,
                    Caixa: parametros.Caixa,
                    Multiplicador: parametros.Multiplicador,
                    DataReferencia: parametros.DataReferencia,
                    DataProcessamento: parametros.DataProcessamento
                }])
            } else {
                setRowsParametros([])
            }
            setTabIndex(0)
            setOpenModalDetailSubordinacao(true)
        }).catch(() => {
            props.openAlert("Erro ao abrir os dados do histórico, tente novamente...", "error")
            setOpenModalDetailSubordinacao(false)
        }).finally(() => props.setLoading(false))
    }

    const exportExcel = (params) => {
        props.setLoading(true)
        const { row } = params
        const { uuid, NomeSimulacao } = row

        service.getHistoricoSimulado(uuid).then((response) => {
            const { body } = response
            const { results, subordinacaoEntrada } = body

            service.exportExcel(NomeSimulacao, results, subordinacaoEntrada)
        }).catch(() => {
            props.openAlert("Erro ao abrir os dados do histórico, tente novamente...", "error")
            setOpenModalDetailSubordinacao(false)
        }).finally(() => props.setLoading(false))
    }

    const columns = [
        {
            field: 'id',
            headerName: '#',
            minWidth: 80,
        },
        {
            field: 'NomeSimulacao',
            headerName: 'Simulação',
            flex: true,
            minWidth: 300
        },
        {
            field: 'DataReferencia',
            headerName: 'Data Referência',
            flex: true,
            minWidth: 200,
        },
        {
            field: 'DataProcessamento',
            headerName: 'Data Processamento',
            flex: true,
            minWidth: 200,
        },
        {
            field: 'Usuario',
            headerName: 'Usuário',
            flex: true,
            minWidth: 200,
            valueGetter: ({ value }) => value && value.Nome,
        },
        {
            field: 'CriadoEm',
            headerName: 'Criado Em',
            flex: true,
            minWidth: 200,
            valueGetter: ({ value }) => value && dayjs(value).toDate(),
            valueFormatter: params => formatDateUtc(params.value, DATE_TIME_FORMAT_SHOW),
        },
        {
            field: 'Consulta',
            headerName: 'Consulta',
            flex: true,
            minWidth: 200,
            renderCell: (params) => (
                <Grid container spacing={1}>
                    <Grid item>
                        <Button variant="outlined" color={"primary"} onClick={() => openModalDetail(params)}>Abrir</Button>
                    </Grid>
                    <Grid item>
                        <Button variant="outlined" color={"success"} onClick={() => exportExcel(params)}>Excel</Button>
                    </Grid>
                </Grid>
            )
        },
    ]

    const columnsDetail = [
        {
            field: 'ID',
            headerName: '#',
            flex: 1,
        },
        {
            field: 'NomeCota',
            headerName: 'Nome da Cota',
            flex: 1,
            minWidth: 140
        },
        {
            field: 'PLCota',
            headerName: 'PL da Cota',
            flex: 1,
            minWidth: 120,
            renderCell: (params) => formatStringToFloatDecimalCase(params.value)
        },
        {
            field: 'IndexadorCota',
            headerName: 'Indexador',
            flex: 1,
            minWidth: 120,
        },
        {
            field: 'TaxaAccrualCota',
            headerName: 'Taxa Accrual',
            flex: 1,
            minWidth: 120,
            renderCell: (params) => formatStringToFloatDecimalCase(params.value)
        },
        {
            field: 'DurationCota',
            headerName: 'Duration Cota',
            flex: 1,
            minWidth: 120,
            renderCell: (params) => formatStringToFloatDecimalCase(params.value)
        },
        {
            field: 'SubordinacaoContabilCota',
            headerName: 'Subordinação',
            flex: 1,
            minWidth: 120,
            renderCell: (params) => formatStringToFloatDecimalCase(params.value)
        },
        {
            field: 'RatingCota',
            headerName: 'Rating',
            flex: 1,
            minWidth: 120,
            renderCell: (params) => params.value
        },
        {
            field: 'TaxaMTMCota',
            headerName: 'Taxa MTM',
            flex: 1,
            minWidth: 120,
            renderCell: (params) => formatStringToFloatDecimalCase(params.value)
        },
        {
            field: 'SpreadMTMCota',
            headerName: 'Spread',
            flex: 1,
            minWidth: 120,
            renderCell: (params) => formatStringToFloatDecimalCase(params.value)
        },
        {
            field: 'PDCota',
            headerName: 'PD',
            flex: 1,
            minWidth: 120,
            renderCell: (params) => formatStringToFloatDecimalCase(params.value)
        },
        {
            field: 'LGDCota',
            headerName: 'LGD',
            flex: 1,
            minWidth: 120,
            renderCell: (params) => formatStringToFloatDecimalCase(params.value)
        },
        {
            field: 'EADCota',
            headerName: 'EAD',
            flex: 1,
            minWidth: 120,
            renderCell: (params) => formatStringToFloatDecimalCase(params.value)
        },
        {
            field: 'PerdaEsperadaCota',
            headerName: 'Perda Esperada',
            flex: 1,
            minWidth: 120,
            renderCell: (params) => formatStringToFloatDecimalCase(params.value)
        },
        {
            field: 'CreditVaRCota',
            headerName: 'Credit VaR',
            flex: 1,
            minWidth: 120,
            renderCell: (params) => formatStringToFloatDecimalCase(params.value)
        },
        {
            field: 'CreditTailVarCota',
            headerName: 'Credit Tail VaR',
            flex: 1,
            minWidth: 120,
            renderCell: (params) => formatStringToFloatDecimalCase(params.value)
        },
        {
            field: 'DataReferenciaOriginal',
            headerName: 'Data Referência',
            flex: 1,
            minWidth: 150,
            valueGetter: ({ value }) => value && dayjs(value).toDate(),
            valueFormatter: params => dayjs(params.value).format(DATE_FORMAT_SHOW),
        },
        {
            field: 'DataReferencia',
            headerName: 'Data Processamento',
            flex: 1,
            minWidth: 150,
            valueGetter: ({ value }) => value && dayjs(value).toDate(),
            valueFormatter: params => dayjs(params.value).format(DATE_FORMAT_SHOW),
        }
    ]

    const columnsParametros = [
        { field: 'TipoSimulacao', headerName: 'Tipo Simulação', flex: 1 },
        { field: 'TipoPDD', headerName: 'Tipo PDD', flex: 1 },
        { field: 'NomeCarteira', headerName: 'Nome Carteira', flex: 1 },
        { field: 'QuantidadeOperacoes', headerName: 'Qtd Operações', flex: 1 },
        {
            field: 'PLTotal',
            headerName: 'PL Total',
            flex: 1,
            valueFormatter: (params) => formatStringToFloatDecimalCase(String(params.value ?? 0))
        },
        { field: 'Percentil', headerName: 'Percentil', flex: 1 },
        {
            field: 'Caixa',
            headerName: 'Caixa',
            flex: 1,
            valueFormatter: (params) => formatStringToFloatDecimalCase(String(params.value ?? 0))
        },
        { field: 'Multiplicador', headerName: 'Multiplicador', flex: 1 },
        {
            field: 'DataReferencia',
            headerName: 'Data Referência',
            flex: 1,
            valueGetter: ({ value }) => value && dayjs(value).toDate(),
            valueFormatter: (params) =>
                dayjs(params.value).format(DATE_FORMAT_SHOW)
        },
        {
            field: 'DataProcessamento',
            headerName: 'Data Processamento',
            flex: 1,
            valueGetter: ({ value }) => value && dayjs(value).toDate(),
            valueFormatter: (params) =>
                dayjs(params.value).format(DATE_FORMAT_SHOW)
        }
    ]

    return <>
        <Paper>
            <DataGrid
                autoHeight
                rows={rows}
                columns={columns}
                sortingOrder={['asc', 'desc']}
                disableRowSelectionOnClick
                localeText={localeBRDataGridText}
            />
        </Paper>

        <ModalDialogPage open={openModalDetailSubordinacao}
            title="Detalhe da Simulação"
            close={() => {
                setOpenModalDetailSubordinacao(false)
            }}>
                <Tabs value={tabIndex} onChange={(_, v) => setTabIndex(v)}> 
                    <Tab label="Resultados" /> 
                    <Tab label="Parâmetros" /> 
                </Tabs>
            <>
                <Grid container direction="column">
                    <Grid item xs={12} md={12} xl={12} style={{ minHeight: 300 }}>
                        {tabIndex === 0 && (
                            <DataGrid
                                autoHeight
                                getRowHeight={() => 52}
                                rows={rowsSubordinacaoSimulado}
                                columns={columnsDetail}
                                sortingOrder={['asc', 'desc']}
                                disableRowSelectionOnClick
                                localeText={localeBRDataGridText}
                            />
                        )}
                        {tabIndex === 1 && (
                            <Box sx={{ minHeight: 300 }}>
                                <DataGrid
                                autoHeight
                                rows={rowsParametros}
                                columns={columnsParametros}
                                hideFooter
                                disableRowSelectionOnClick
                                localeText={localeBRDataGridText}
                                />
                            </Box>
                        )}
                    </Grid>
                </Grid>
            </>
        </ModalDialogPage>
    </>
}

SimuladorSubordinacaoHistorico.propTypes = {
    setLoading: PropTypes.func,
    openAlert: PropTypes.func,
}

export default SimuladorSubordinacaoHistorico